import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import '../component/WeeklyBundle.css'

const bundleFeatures = [
  'Weekly Consolidated Shipping',
  'Friday Checkout Release',
  'Unpaid Win Protection System',
  'Auto Reminders & Notifications',
]

function WeeklyBundle() {
  const sectionRef = useRef(null)
  const leftRef = useRef(null)
  const rightRef = useRef(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        defaults: { ease: 'power3.out' },
      })

      tl.from(sectionRef.current, { opacity: 0, duration: 0.4 })
        .from(leftRef.current.children, {
          opacity: 0,
          y: 26,
          scale: 0.96,
          duration: 0.6,
          stagger: 0.08,
        })
        .from(
          rightRef.current.children,
          {
            opacity: 0,
            y: 22,
            duration: 0.55,
            stagger: 0.12,
          },
          '-=0.35'
        )
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (
    <section className="weekly-bundle-section" ref={sectionRef}>
      <div className="weekly-bundle-container">
        <div className="weekly-bundle-left" ref={leftRef}>
          {bundleFeatures.map((item, index) => (
            <div className="weekly-feature-box" key={index}>
              <h3>{item}</h3>
            </div>
          ))}
        </div>

        <div className="weekly-bundle-right" ref={rightRef}>
          <span className="weekly-bundle-badge">
            Buy all week, Ship once, Every Friday
          </span>

          <h2 className="weekly-bundle-title">
            Weekly Bundle
            <br />
            Shipping Stack
            <br />
            Wins, Save More
          </h2>

          <p className="weekly-bundle-text">
            We don’t just ship cards — we optimize collections. Hold your wins
            throughout the week and combine everything into a single weekly shipment.
            Less shipping cost, more efficiency, and total control over your deliveries.
          </p>

          <div className="weekly-bundle-buttons">
            <button type="button">Enable Weekly Bundle</button>
            <button type="button">Manage Active Holds</button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WeeklyBundle
